import React from 'react';
import { getText } from '../helpers';

const ExportButton = ({ onClick, loading, disabled }) => {
  return (
    <a
      className="export-to-excel-button"
      onClick={onClick}
      loading={loading}
      disabled={disabled || loading}
    >
      {getText('Export to Excel')}
    </a>
  );
};

export default ExportButton;


// WEBPACK FOOTER //
// ./src/components/export_to_excel_button.js